export default "__VITE_ASSET__Ycz6Pv4l__"